'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './forgotpassword.routes';

export class ForgotpasswordComponent {
  /*@ngInject*/
  constructor($http, $scope, Auth, $anchorScroll, $state) {
    this.$http = $http;
    this.$scope = $scope;
    this.$state = $state;
    this.$scope.notes = 'A temporary password will be emailed to you';
    this.$scope.submitted = false;

  }

  onInit(){

  }

  resetPassword(){
    console.log(this.user);
    this.$http.post('/api/users/password',this.user)
    .then(response => {
      console.log(response);
     if(response.data.status === 'updated'){
      this.$scope.submitted = true;
      this.user = {};
      this.$scope.notes = "Your temporary password has been sent. Please check you email. If you don't see it in your inbox, be sure to also check your spam/junk folder for the email from support@mtcanalytics.org"; 
     } else if(response.data.status === 'error'){
      this.$scope.submitted = true;
      this.$scope.notes = "You have entered an email that is not yet registered."; 
     }
    })
    .catch(err => {
      console.log(err);
    })
  }
}

export default angular.module('hessApplicationApp.forgotpassword', [uiRouter])
  .config(routes)
  .component('forgotpassword', {
    template: require('./forgotpassword.html'),
    controller: ForgotpasswordComponent,
    controllerAs: 'forgotpasswordCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/forgotpassword/forgotpassword.component.js